import type { Queue } from "@/lib/api/system";
import { QUEUE_TYPE, QueueFormShape, type QueueFormValues } from "./form-schema";

export function apiToForm(queue: Queue): QueueFormValues {
  return {
    queue_type: QUEUE_TYPE,
    max_concurrent: queue.max_concurrent,
  };
}

export function formToUpdateApi(form: QueueFormValues, queueId: number) {
  const parsed = QueueFormShape.parse(form);

  return {
    id: queueId,
    max_concurrent: parsed.max_concurrent,
  };
}
